import React from 'react';
import PhoneInput from 'react-phone-number-input'
import { PropTypes } from "prop-types";
import 'react-phone-number-input/style.css'
import './index.css';
import { FormControl, FormHelperText, useTheme } from '@mui/material';
import { includes, isEmpty } from 'lodash';
import MapitPhoneInputComponent from './MapitPhoneInputComponent';
import { MapitInputLabel } from '../basic-components';
import { useTranslation } from 'react-i18next';

const MapitPhoneInput = ({
    countries,
    defaultCountry,
    value,
    handleChange,
    error,
    children,
    containerProps,
    optional,
    ...props
}) => {
    const { t } = useTranslation("auth");

    const theme = useTheme();

    const handleChangeInside = value => {
        const e = { target: { name: props.name, value } }
        handleChange(e)
    }

    return (
        <FormControl dir="ltr" error={Boolean(error)} fullWidth variant="standard">
            <MapitInputLabel shrink htmlFor={props?.name} style={{ direction: theme?.direction }}>
                {props?.label}
                {optional &&
                    <span
                        style={{
                            marginRight: "7px",
                            marginLeft: "7px",
                            color: "#98A2B3",
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "20px",
                        }}>
                        {`(${t("form.optional")})`}
                    </span>
                }
                {props?.required && <span>{" *"}</span>}
            </MapitInputLabel>
            <PhoneInput
                placeholder="50 xxxxxxxx"
                value={value}
                onChange={handleChangeInside}
                defaultCountry={defaultCountry}
                countries={countries}
                addInternationalOption={false}
                international={true}
                countryCallingCodeEditable={false}
                error={!!error}
                inputComponent={MapitPhoneInputComponent}
                flags={{
                    SA: (props) => <img alt="sa" width={"100%"} src={require("./flags/SA.svg").default} />,
                    EG: (props) => <img alt="eg" width={"100%"} src={require("./flags/EG.svg").default} />
                }}
                dir="ltr"
                style={{
                    padding: '10px 14px',
                    borderRadius: 6,
                    backgroundColor: '#FFFFFF',
                    border: '1px solid',
                    borderColor: '#D0D5DD',
                    transition: theme.transitions.create([
                        'border-color',
                        'background-color',
                        'box-shadow',
                    ]),
                    marginTop: !!props?.label ? theme.spacing(3) : undefined,
                }}
                {...props}
            />
            <FormHelperText>{error}</FormHelperText>
        </FormControl>
    )
}

MapitPhoneInput.propTypes = {
    countries: PropTypes.array.isRequired,
    defaultCountry: function (props, propName, componentName) {
        if (
            props['countries'] &&
            !isEmpty(props['countries']) &&
            !includes(props['countries'], props[propName])
        ) {
            return new Error(
                'Invalid prop `' + propName + '` supplied to' +
                ' `' + componentName + '`. Expected one of: ' + JSON.stringify(props['countries'])
            );
        }
    },
    value: PropTypes.string,
    handleChange: PropTypes.func.isRequired,
    error: PropTypes.string,
    containerProps: PropTypes.object,
    props: PropTypes.object
};

MapitPhoneInput.defaultProps = {
    countries: ["SA", "EG", "AE"],
    defaultCountry: "SA",
};

export default MapitPhoneInput;